module.exports = __webpack_public_path__ + "img/11.68b912ed.png";